import titanium from "../../../../public/projects/signatureglobal/images/projects/signatureglobaltitanium.webp";
import logo from "../../../../public/projects/signatureglobal/images/logo/logo.png";

// Titanium
import overviewImage_titanium from "../../../../public/projects/signatureglobal/images/titanium/Overview/1.webp";
import bannerDesktopImage_titanium from "../../../../public/projects/signatureglobal/images/titanium/Banner/1.webp";
import bannerMobileImage_titanium from "../../../../public/projects/signatureglobal/images/titanium/Banner/2.webp";
import siteVisitBannerImage_titanium from "../../../../public/projects/signatureglobal/images/titanium/SiteVisitBanner/1.webp";
import Location_titanium from "../../../../public/projects/signatureglobal/images/titanium/Location/L1.webp";
import Hightlights_titanium from "../../../../public/projects/signatureglobal/images/titanium/Highlights/1.webp";
import image1BHK_titanium from "../../../../public/projects/signatureglobal/images/titanium/floorplan/1.webp";
import image2BHK_titanium from "../../../../public/projects/signatureglobal/images/titanium/floorplan/2.webp";
import location_titanium from "../../../../public/projects/signatureglobal/images/titanium/Overview/l.png";
import cal_titanium from "../../../../public/projects/signatureglobal/images/titanium/Overview/c.png";
import newlaunch_titanium from "../../../../public/projects/signatureglobal/images/titanium/Overview/n.png";
import g1_titanium from "../../../../public/projects/signatureglobal/images/titanium/Gallery/1.webp";
import g2_titanium from "../../../../public/projects/signatureglobal/images/titanium/Gallery/2.webp";
import g3_titanium from "../../../../public/projects/signatureglobal/images/titanium/Gallery/3.webp";
import g4_titanium from "../../../../public/projects/signatureglobal/images/titanium/Gallery/4.webp";
import g5_titanium from "../../../../public/projects/signatureglobal/images/titanium/Gallery/5.webp";

export const developersSignatureGlobal = {
  name: `Signature Global Properties in Gurugram`,
  properties: [
    {
      name: "Signature Global - Titanium SPR",
      image: titanium,
      price: "On Request",
      location: "sector 71",
      bed: "3.5 - 4.5 BHK ",
      state: "Gurugram",
      projectlocation: "SPR Road",
      developer: "Signature Global",
      size: "....",
      url: `/signature-global-titanium-spr-sector-71-gurugram`,
      form: {
        source_id: 11,
        api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
        api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
        sub_source_id: 130,
        builder_id: `103`,
        project_id: `477`,
        subject: "M3M Altitude", // Add or update the subject here
        to_email: "jatin.rohilla@propertystation.in",
      },
    },
  ],
};

export const Headers = {
  logo: logo,
  data: {
    experience: `2024`,
    projects: `118`,
    ongoingprojects: `18`,
  },
  about: `Signature Global, a leading real estate development company in India, is reshaping the housing market 
  in northern India. Initially established as a key player in affordable and mid-housing, the company successfully 
  transitioned to the premium housing segment in 2024, marked by the successful launch of two group housing projects
   with record sales value. The company now focuses on the mid-housing and premium segments, emphasizing quality
    execution, value creation, reliability, and adherence to global standards. Signature Global holds a market share of 
    13% in the Delhi NCR region and 27% in the micro markets of Gurugram within these segments. `,
};

export const projectssignatureglobal = {
  signatureglobal: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImage_titanium,
      bannerMobileImage: bannerMobileImage_titanium,
      textOverlay: "",
      data: {
        title: "Signature Global Titanium SPR",
        subtitle: "Sector 71, Gurgaon",
        starting_price: "On Request",
        payment_plan: "....",
        rerano: "GGM/831/563/2024/58",
        status: "New Launch",
      },
    },
    overview: {
      heading: "Discover Luxury Living at Signature Global Titanium SPR",
      description: [
        `Here’s a shuffled version of your text while maintaining clarity and flow:  
Nestled in the heart of Gurugram’s Sector 71, Signature Global Titanium SPR stands as a testament to strength, durability, and prestige. Much like its namesake
 metal, it exudes robustness and resilience, offering a sanctuary of timeless elegance and enduring quality.  
This esteemed project thrives in a vibrant sector that has captured the spotlight, driven by its expansive road networks, ongoing infrastructure enhancements, 
and the active participation of real estate developers. Here, urban dreams intertwine with the pulse of city life, 
shaping a future where excellence meets opportunity.  
Let me know if you'd like any further refinements.`,
      ],
      image: overviewImage_titanium,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: location_titanium,
          title: "On Request ",
          subtitle: "Starting Price",
        },
        {
          iconClass: cal_titanium,
          title: "....",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunch_titanium,
          title: "New Launch",
          subtitle: "Status",
        },
      ],
    },

    sitevisit: {
      image: siteVisitBannerImage_titanium,
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "3 BHK Apartment",
          area: "2780 sq. ft.",
          price: "On Request",
          eoiAmount: "On Request",
        },
        {
          type: "4 BHK Apartment",
          area: "3780 sq. ft.",
          price: "On Request",
          eoiAmount: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "3 BHK Apartment",
        area: "2780 sq. ft.",
        price: "On Request",
        image: image1BHK_titanium,
      },
      {
        type: "4 BHK Apartment",
        area: "3780 sq. ft.",
        price: "On Request",
        image: image2BHK_titanium,
      },
    ],

    highlights: {
      images: Hightlights_titanium,
      tagline: "Highlights",
      features: [
        "Double Height Club Entrance Lobby.",
        "3.6 mtr Floor to Floor Height.",
        " Sky garden at 30th Floor.",
        "Sky Terrace.",
        " Security system on every spot.",
      ],
    },

    location: {
      image: Location_titanium,
      data:[
        {
          airport:{
            distance_time:"2 kms",
            name:"to IGI"
          },
          school:{
            distance_time:"3 Kms",
            name:"to DPS"
          },
          railwayormetro:{
            distance_time:"3 Kms",
            name:"to Gurugram"
          },
          hospital:{
            distance_time:"2 Kms",
            name:" to IGI"
          },
          mall:{
            distance_time:"1 Kms",
            name:"to Big Bazzar"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: g1_titanium },
        { image: g2_titanium },
        { image: g3_titanium },
        { image: g4_titanium },
        { image: g5_titanium },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in Signature Global Titanium SPR, kindly share more details.",
    },

    faq: [
      {
        question: "What is the price range of Signature Global Titanium SPR?",
        answer: `The price range is approximately ₹4.5 crore to ₹7 crore.`,
      },
      {
        question: "What are the available apartment sizes in this project?",
        answer: `The apartments range from 2,780 to 3,780 sq. ft.`,
      },
      {
        question: "Where is Signature Global Titanium SPR located?",
        answer: `It is situated at Signature Global Titanium 71, SPR Road, Gurugram.`,
      },
      {
        question: "What is the current construction status of the project",
        answer: `The project is currently under construction.`,
      },
      {
        question: "When is the expected possession date?",
        answer: `The possession date is projected for the third quarter of 2028.`,
      },
      {
        question: "How large is the total land area of Signature Global Titanium SPR?",
        answer: `The project spans 22 acres.`,
      },
      {
        question: "How many units and towers are there?",
        answer: `The development comprises 600 units across 7 towers.`,
      },
      {
        question: "What type of furnishing is provided?",
        answer: `The apartments come fully furnished.`,
      },
      {
        question: "Is the project RERA registered?",
        answer: `Yes, it is registered with RERA under the number RC/REP/HARERA/GGM/831/563/2024/58, dated June 3, 2024.`,
      },
      {
        question: "What are some key amenities offered?",
        answer: `Amenities include 24x7 power backup, security, air-conditioned lift lobbies, amphitheater, multiple swimming pools, clubhouse, gym, and more.`,
      },
      {
        question: "What makes Signature Global Titanium SPR a standout choice for homebuyers?",
        answer: `Signature Global Titanium SPR in Sector 71, Gurgaon, stands out as a premier choice for homebuyers seeking luxury, space, and modern amenities.`,
      },
    ],
    similar: {},
    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
       api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
       source_id: 11,
       sub_source_id: 130,
       builder_id: `103`,
       project_id: `477`,
       subject: "Property Station enquiry", // Add or update the subject here
       to_email: "leads@gurugram-property.com",
     },
  },
};
